import { useId } from "react";

/** A stack of images that continuously flip through one another, like a card deck. */
export default function FlipGallery({ images, cycleSeconds = 12, className = "" }) {
  const uid = useId().replace(/[^a-zA-Z0-9]/g, "");
  const n = images.length;
  const slotPct = 100 / n;
  const visibleEnd = Math.max(8, Math.min(slotPct - 4, slotPct * 0.72));
  const animName = `flip_${uid}`;

  const keyframes = `
@keyframes ${animName} {
  0% { transform: rotateX(-100deg); opacity: 0; }
  4% { transform: rotateX(0deg); opacity: 1; }
  ${visibleEnd.toFixed(2)}% { transform: rotateX(0deg); opacity: 1; }
  ${Math.min(slotPct, visibleEnd + 5).toFixed(2)}% { transform: rotateX(-100deg); opacity: 0; }
  100% { transform: rotateX(-100deg); opacity: 0; }
}`;

  return (
    <div className={`flip-gallery ${className}`}>
      <style>{keyframes}</style>
      {images.map((img, i) => (
        <img
          key={img.alt || i}
          src={img.src}
          alt={img.alt}
          loading="lazy"
          className="flip-card"
          style={{
            animationName: animName,
            animationDuration: `${cycleSeconds}s`,
            animationTimingFunction: "ease-in-out",
            animationIterationCount: "infinite",
            animationDelay: `${(i * slotPct / 100) * cycleSeconds}s`,
          }}
        />
      ))}
    </div>
  );
}
